import React from "react";

function DashboardNotFound() {
	return (
		<p>Insights not configured for this ArcTag. Please reach out to your ArcSpan representative for more assistance.</p>
	);
}

export default DashboardNotFound;
